export const getEnterprisesCredentials = () => {
  return {
    accept: "application/json",
    "client-id": process.env.REACT_APP_CLIENTID.toUpperCase(),
    "client-key": process.env.REACT_APP_PME_CLIENT_KEY,
    "x-client-key": process.env.REACT_APP_PME_XCLIENT_KEY,
  };
};
